module.exports = __webpack_public_path__ + "static/logo-caption_2-42f0b44264f030a151dc0b296d33c112.png";